import type { FC, SVGProps } from 'react';

export interface IconComponentProps extends Omit<SVGProps<SVGSVGElement>, 'height' | 'width'> {
    color?: string;
    size?: number;
}

export interface IconProps extends SVGProps<SVGSVGElement> {
    size?: 16 | 20 | 24;
}

export interface BaseIconProps extends IconProps {
    Component: FC<IconComponentProps>;
}

export const BaseIcon: FC<BaseIconProps> = ({ Component, size = 16, strokeWidth = 1.75, ...props }) => (
    <Component {...props} size={size} strokeWidth={strokeWidth} />
);
